export const setAuth = (token, user, accounts) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('accounts', JSON.stringify(accounts || []));
  
  // Auto-select account if only one exists
  if (accounts && accounts.length === 1) {
    localStorage.setItem('current_account', JSON.stringify(accounts[0]));
  }
};

export const getAuth = () => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const accountsStr = localStorage.getItem('accounts');
  const user = userStr ? JSON.parse(userStr) : null;
  const accounts = accountsStr ? JSON.parse(accountsStr) : [];
  return { token, user, accounts };
};

export const getCurrentAccount = () => {
  const accountStr = localStorage.getItem('current_account');
  return accountStr ? JSON.parse(accountStr) : null;
};

/**
 * Resolve the display name of the active org's partner (e.g. "Anchor",
 * "Bill Portal-US"). Returns null when the org has no partner — callers
 * should hide the "Partner" option in that case.
 *
 * Source preference:
 *   1. account.partner_name      (denormalised by sync_service)
 *   2. account.bp_partner_name   (legacy denormalised field)
 *   3. null                      (no partner)
 */
export const getCurrentPartnerName = () => {
  const acc = getCurrentAccount();
  if (!acc) return null;
  return acc.partner_name || acc.bp_partner_name || null;
};

export const setCurrentAccount = (account) => {
  localStorage.setItem('current_account', JSON.stringify(account));
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('accounts');
  localStorage.removeItem('current_account');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const isSuperAdmin = () => {
  const { user } = getAuth();
  return user?.is_super_admin || user?.is_owner || false;
};

export const isOwner = () => {
  const { user } = getAuth();
  return user?.is_owner || false;
};

export const isOpsAdmin = () => {
  const { user } = getAuth();
  return user?.is_ops_admin || false;
};

export const canSeeAiManager = () => {
  const { user } = getAuth();
  return Boolean(user?.is_super_admin || user?.is_owner || user?.is_ops_admin);
};

export const isSuperPfAdmin = () => {
  const { user } = getAuth();
  return user?.is_super_pf_admin || false;
};

export const isOpsPf = () => {
  const { user } = getAuth();
  return user?.is_ops_pf || false;
};

// Can the user access Super Admin > Payments space?
// Super admins, Owners, Ops Admins (for issue flags), and Ops PF (for payment ops).
export const canAccessSuperAdminPayments = () => {
  const { user } = getAuth();
  return Boolean(user?.is_super_admin || user?.is_owner || user?.is_ops_admin || user?.is_ops_pf);
};

export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};
